module.exports = __webpack_public_path__ + "img/result-empty.992af7bb.png";